import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconWatch(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.354 4.107v-.003l.209-2.285a2 2 0 0 1 1.991-1.82h2.897a2 2 0 0 1 2 1.819l.21 2.302a5.32 5.32 0 0 1 1.672 3.879 5.32 5.32 0 0 1-1.687 3.892l-.209 2.288a1.999 1.999 0 0 1-1.997 1.82H6.556a2 2 0 0 1-2-1.819l-.21-2.295A5.32 5.32 0 0 1 2.666 8a5.32 5.32 0 0 1 1.687-3.893zm1.426-.958A5.313 5.313 0 0 1 8 2.666c.798 0 1.554.175 2.234.489l-.111-1.216a.668.668 0 0 0-.669-.607H6.555a.666.666 0 0 0-.663.607zm-.007 9.699.111 1.212a.668.668 0 0 0 .669.607h2.889a.667.667 0 0 0 .667-.607l.11-1.209a5.313 5.313 0 0 1-2.22.483 5.312 5.312 0 0 1-2.227-.486zM8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm1.471-3.471a.668.668 0 0 1-.943.943l-1-1a.667.667 0 0 1-.195-.471v-2a.667.667 0 1 1 1.334 0v1.724z"
  }));
}
IconWatch.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconWatch.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconWatch as default };
